import React from 'react'
import {
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material'
import { Home, Menu as MenuIcon, SearchOutlined } from '@mui/icons-material'
import { DashboardNavbarRoot } from './styled/Dashboard.styles'
import { useNavigate } from 'react-router-dom'

interface AppBarProps {
  onMenuClick: () => void
  onHomeClick: () => void
  siteLogo: string
  logoLucija: string
  logoSst: string
  headerImage: string
}

export const AppBar: React.FC<AppBarProps> = ({
  onMenuClick,
  onHomeClick,
  siteLogo,
  logoLucija,
  logoSst,
  headerImage
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <DashboardNavbarRoot>
      <Toolbar
        sx={{
          height: { xs: 56, sm: 64 },
          minHeight: { xs: 56, sm: 64 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 1, sm: 2 }
        }}
      >
        {/* Left Section - Navigation Icons */}
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <IconButton
            size={isMobile ? 'small' : 'large'}
            color='inherit'
            aria-label='menu'
            onClick={onMenuClick}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            size={isMobile ? 'small' : 'large'}
            color='inherit'
            aria-label='home'
            onClick={onHomeClick}
          >
            <Home />
          </IconButton>
        </Box>

        {/* Center Section - Logo */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1
          }}
        >
          <Button
            onClick={onHomeClick}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={siteLogo}
              alt='logo'
              style={{
                height: isMobile ? 25 : isTablet ? 30 : 40,
                maxWidth: '100%'
              }}
            />
          </Button>
        </Box>

        {/* Right Section - Search and Secondary Logos */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flex: 1,
            gap: { xs: 1, sm: 2 }
          }}
        >
          {/* Search Button */}
          <Button
            variant='text'
            onClick={() => navigate('/pytac')}
            endIcon={<SearchOutlined htmlColor='white' />}
            size={isMobile ? 'small' : 'medium'}
            sx={{
              px: { xs: 1, sm: 2 },
              '& .MuiTypography-root': {
                fontSize: { xs: '0.875rem', sm: '1rem' }
              }
            }}
          >
            <Typography color='white'>Pytać</Typography>
          </Button>

          {/* Secondary Logos - hidden on mobile */}
          {!isMobile && (
            <>
              <a
                href='https://lucija.de'
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <img
                  src={logoLucija}
                  alt='logo'
                  style={{
                    height: isTablet ? 30 : 40,
                    maxWidth: '100%'
                  }}
                />
              </a>
              <a
                href='https://www.sorbischer-schulverein.de/hs'
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <img
                  src={logoSst}
                  alt='logo'
                  style={{
                    height: isTablet ? 30 : 40,
                    maxWidth: '100%'
                  }}
                />
              </a>
            </>
          )}
        </Box>
      </Toolbar>

      {/* Header line image - responsive positioning */}
      <img
        src={headerImage}
        alt='header_line'
        style={{
          height: isMobile ? 15 : 20,
          objectFit: 'cover',
          zIndex: 3,
          position: 'absolute',
          top: isMobile ? 46 : 54,
          width: '100%'
        }}
      />
    </DashboardNavbarRoot>
  )
}
